import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = ["stroke"]
const _hoisted_3 = ["stroke"]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'strikesIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#DBDBDB",
  },
  size: {
    type: Number as PropType<number>,
    default: 9,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: __props.size,
    height: __props.size,
    viewBox: `0 0 ${__props.size} ${__props.size}`,
    fill: "none"
  }, [
    _createElementVNode("path", {
      d: "M1.46447 4.53553L5 1",
      stroke: __props.color,
      "stroke-linecap": "round"
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M1.42893 8.07107L8.5 1",
      stroke: __props.color,
      "stroke-linecap": "round"
    }, null, 8, _hoisted_3)
  ], 8, _hoisted_1))
}
}

})